import ProjectsItem from './ProjectsItem';

export default ProjectsItem;
